import http from '@/utils/http';

export default {
	list: data => http({ url: '/api/admin/v1/workbenchBanner/list', data }),
	detail: data => http({ url: '/api/admin/v1/workbenchBanner/detail', data }),
	create: data => http({ url: '/api/admin/v1/workbenchBanner/create', data, tip: true }),
	update: data => http({ url: '/api/admin/v1/workbenchBanner/update', data, tip: true }),
	delete: data => http({ url: '/api/admin/v1/workbenchBanner/delete', data, tip: true }),
	toggleStatus: data => http({ url: '/api/admin/v1/workbenchBanner/toggleStatus', data, tip: true }),
	uploadImage: data => http({ url: '/api/admin/v1/workbenchBanner/uploadImage', data, files: true }),
};
